import { render, staticRenderFns } from "./Question_C.vue?vue&type=template&id=24a560b9&scoped=true&"
import script from "./Question_C.vue?vue&type=script&lang=js&"
export * from "./Question_C.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a560b9",
  null
  
)

export default component.exports